"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var addOns = _a.addOns, incoming = _a.incoming, length = _a.length;
    if (addOns.map(function (variant) { return variant.id; }).includes(incoming.id)) {
        // variant is already added, remove it
        return addOns.filter(function (variant) { return variant.id !== incoming.id; });
    }
    else if (addOns.length + 1 <= length) {
        // there is room to add the variant
        return addOns.concat(incoming);
    }
    else {
        // there is no room, return the original addOns
        return addOns;
    }
});
